module.exports = __webpack_public_path__ + "img/柴云鹏-4x.3424c3c6.png";